import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import { MemberRepo, MemberRepoUID } from "../repositories/MemberRepo";

export function useMember(memberId: number) {
  const repository = useInjection<MemberRepo>(MemberRepoUID);
  const { data: user, isLoading: loading } = useQuery(
    ["/member/get", { memberId }],
    () => {
      return repository.getMember(memberId);
    }
  );
  return {
    loading,
    user,
  };
}
